import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { AgreementsAutocomplete } from "@shared/components/AutocompleteFields";

export function PromocodeBatchForm() {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="name"
          label={translate("promocode_batch_admin.fields.name")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <AgreementsAutocomplete
          name="agreement"
          label={translate("promocode_batch_admin.fields.agreement")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="quantity"
          label={translate("promocode_batch_admin.fields.quantity")}
          mask="number"
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="active"
          label={translate("promocode_batch_admin.fields.active")}
          required
        />
      </Grid>
    </Grid>

  )
}
